import Home from "./Home";
import PersonConsent from "./PersonConsent";
import ErrorPages from "./ErrorPages";
import Policy from "./Policy";
import { MultiPolicies, PolicyLaspedGreaterThan3Years } from "./MultiPolicies";
import GeneralPages from "./GeneralPages";
import ChooseYourPlan from "./ChooseYourPlan";
import Header from "./Header";
import Footer from "./Footer";
import HealthStore from "./HealthStore";
import MedicalConsent from "./MedicalConsent";
import GDPR from "./GDPR";
import CrestDowntimeNotication from "./CrestDowntimeNotification";
import ContactusForPayment from "./ContactusForPayment";
import ChangeProfileCommon from "./ChangeProfileCommon";
import ChangeAddress from "./ChangeAddress";
import ChangePhoneNumber from "./ChangePhoneNumber";
import ChangePhoneNumberLine from "./ChangePhoneNumberLine";
import ChangeBankDetails  from "./ChangeBankDetails";
import ChangeBankDetailsInLine from "./ChangeBankDetailsLine";
import Check4Cancer from "./Check4Cancer";
import ProductType from "./ProductType";
import MyProfileHeader from "./MyProfileHeader";
import MyProfile from "./MyProfile";
import MyProfileContactPreferences from "./MyProfileContactPreferences";
import MyProfileCommunicationNeeds from "./MyProfileCommunicationNeeds";
import CustomisedPreference from "./CustomisedPreference";
import Permissions from "./Permissions";
import Claims from "./Claims";
import HowToClaim from "./HowToClaim";
import HealthSupport from "./HealthSupport";
import GPAppointments247 from "./GPAppointments247";
import PromoCards from "./PromoCards";
import FileDownloadList, {
  FileDownloadHeaders
} from "./download/FileDownloadListContent";
import AddAPlan from "./AddAPlan";
import AddAPlanSuccess from "./AddAPlanSuccess";
import Cover from "./Cover";
import MakeChangesToCover from "./MakeChangesToCover";
import MembershipInfoSaga from "./MembershipInfoSaga";
import ClaimDetails from "./ClaimDetails";
import CoverTooltip, { BenefitSectionTooltips } from "./CoverTooltip";
import CoverDocuments from "./CoverDocuments";
import PaymentDetails from "./PaymentDetails";
import HealthInformation from "./HealthInformation";
import WorkingBody from "./WorkingBody";
import AskAMedicalExpert from "./AskAMedicalExpert";
import FastTrackAppointments from "./FastTrackAppointments";
import ClaimsWrapper from "./ClaimsWrapper";
import ExitSurvey from "./ExitSurvey";
import MakeAClaim from "./MakeAClaim";
import CookieBar from "./banners/CookieBar";
import ChooseClaimType from "./makeAClaim/ChooseClaimType";
import IsNewClaimCondition from "./makeAClaim/IsNewClaimCondition";
import DoYouNeedAuthorisation from "./makeAClaim/DoYouNeedAuthorisation";
import GetStartedButton from "./makeAClaim/GetStartedButton";
import DoesNotRequireAuthorisation from "./makeAClaim/DoesNotRequireAuthorisation";
import ContactUs from "./ContactUs";
import ClaimBackOptions from "./makeAClaim/ClaimBackOptions";
import InPatient from "./makeAClaim/InPatient";
import DentalOrOptical from "./makeAClaim/DentalOrOptical";
import PrivateGPFees from "./makeAClaim/PrivateGpFees";
import ChiropodyPodiatry from "./makeAClaim/ChiropodyPodiatry";
import ChildBirth from "./makeAClaim/ChildBirth";
import Chemotherapy from "./makeAClaim/Chemotherapy";
import Radiotherapy from "./makeAClaim/Radiotherapy";
import ClaimBackChemoOrRadiotherapy from "./makeAClaim/ClaimBackChemoOrRadiotherapy";
import Appointments from "./Appointments";
import MedicalTreatment from "./makeAClaim/MedicalTreatment";
import Renewal from "./Renewal";
import InboxLink from "./inbox/InboxLink";
import InboxStatus from "./inbox/InboxStatus";
import Notifications from "./Notifications";
import Manifest from "./Manifest";
import MakeAClaimButton from "./MakeAClaimButton";
import QueryForHBS from "./makeAClaim/QueryForHBS";
import AreYouThePatient from "./makeAClaim/AreYouThePatient";
import HbsPopup from "./makeAClaim/HbsPopup";
import GeneralEnquirySmartLink from "./GeneralEnquirySmartLink";
import UploadDocumentSmartLink from "./UploadDocumentSmartLink";
import AskAMedicalExpertSmartLink from "./AskAMedicalExpertSmartLink";
import MakeAClaimSmartLink from "./MakeAClaimSmartLink";
import MakeAComplaintSmartLink from "./MakeAComplaintSmartLink";
import HeaderMenu from "./header/HeaderMenu";
import Logout from "./header/Logout";
import SMEDentalOrOptical from "./makeAClaim/SMEDentalOrOptical";
import SMEPrivateGPFees from "./makeAClaim/SMEPrivateGpFees";
import LoggedOut from "./logout/LoggedOut";
import MemberDetails from "./onboarding/MemberDetails";
import MembershipNumber from "./onboarding/MembershipNumber";
import { SpecialInformationBannerContent } from "./banners/SpecialInformationBanner";
import { SpecialInformationSplitBannerContent } from "./banners/SpecialInformationSplitBanner";
import { popupBlockerContent } from "./features/PopupBlockerContent";
import { TimeSettingsContent } from "./information/errors/TimeSettings";
import { fileDownloadRetryLinkContent } from "./download/FileDownloadRetryLinkContent";
import LinkAPlan from "./LinkAPlan";
import AddAPlanLink from "./AddAPlanLink";
import { MovedToAxaHealth } from "./information/errors/MovedToAxaHealth";
import SendAnInvoiceSmartLink from "./SendAnInvoiceSmartLink";
import Check4CancerProstate from "./Check4CancerProstate";
import Check4CancerSkin from "./Check4CancerSkin";
import Check4CancerBreast from "./Check4CancerBreast";
import CancerDiagnosticServices from "./CancerDiagnosticServices";
import HealthHub from "./HealthSupport";
import MFAErrorPage from "./MFAErrorPage";
const Store = {
  SMEPrivateGPFees,
  SMEDentalOrOptical,
  Logout,
  Policy,
  HeaderMenu,
  MultiPolicies,
  PolicyLaspedGreaterThan3Years,
  Home,
  HealthStore,
  PersonConsent,
  ErrorPages,
  GeneralPages,
  ChooseYourPlan,
  Header,
  Footer,
  ProductType,
  MedicalConsent,
  GDPR,
  Claims,
  DoYouNeedAuthorisation,
  DoesNotRequireAuthorisation,
  ClaimsWrapper,
  GetStartedButton,
  HowToClaim,
  MyProfileHeader,
  MyProfile,
  MyProfileContactPreferences,
  ChangeAddress,
  ChangeProfileCommon,
  ChangePhoneNumber,
  ChangeBankDetails,
  ChangeBankDetailsInLine,
  CrestDowntimeNotication,
  ContactusForPayment,
  ChangePhoneNumberLine,
  Check4Cancer,
  Permissions,
  HealthSupport,
  GPAppointments247,
  AddAPlan,
  AddAPlanSuccess,
  PromoCards,
  FileDownloadList,
  FileDownloadHeaders,
  fileDownloadRetryLinkContent,
  Cover,
  MakeChangesToCover,
  MembershipInfoSaga,
  ClaimDetails,
  CoverTooltip,
  BenefitSectionTooltips,
  CoverDocuments,
  PaymentDetails,
  HealthInformation,
  WorkingBody,
  FastTrackAppointments,
  AskAMedicalExpert,
  ExitSurvey,
  MakeAClaim,
  ChooseClaimType,
  CookieBar,
  IsNewClaimCondition,
  ContactUs,
  ClaimBackOptions,
  InPatient,
  DentalOrOptical,
  PrivateGPFees,
  ChiropodyPodiatry,
  ChildBirth,
  Chemotherapy,
  Radiotherapy,
  ClaimBackChemoOrRadiotherapy,
  Appointments,
  MedicalTreatment,
  Renewal,
  InboxLink,
  InboxStatus,
  Notifications,
  Manifest,
  MakeAClaimButton,
  QueryForHBS,
  AreYouThePatient,
  HbsPopup,
  GeneralEnquirySmartLink,
  AskAMedicalExpertSmartLink,
  MakeAClaimSmartLink,
  MakeAComplaintSmartLink,
  LoggedOut,
  MemberDetails,
  SpecialInformationBannerContent,
  SpecialInformationSplitBannerContent,
  MembershipNumber,
  popupBlockerContent,
  TimeSettingsContent,
  LinkAPlan,
  AddAPlanLink,
  MovedToAxaHealth,
  UploadDocumentSmartLink,
  SendAnInvoiceSmartLink,
  CustomisedPreference,
  MyProfileCommunicationNeeds,
  Check4CancerProstate,
  Check4CancerSkin,
  Check4CancerBreast,
  CancerDiagnosticServices,
  HealthHub,
  MFAErrorPage
};

export default Store;
